import { getToken } from "../../helpers/get-token";
import axiosInstance from "../../axios/instance";

async function getEmailTemplate(customization, email_template_type) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/emails/get-email-template', {
            customization,
            email_template_type
        })
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getEmailTemplate;
